import {
  Dropdown,
  ISelectableOption,
  Position,
  SpinButton,
} from '@fluentui/react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { monthList } from '../enums';
import { dropdownStyles } from '../dropdownStyles';
import { useThemeData } from '@msrceng/theme';
import { setYear, setMonth } from 'date-fns';
import { IDateState } from '../types';

/**
 * A UI that lets you pick a date more easily by month/year.
 */
export const YearMonthUi = ({ date, setDate }: IDateState) => {
  const { isDarkMode, theme } = useThemeData();
  const [t] = useTranslation(['search', 'translation']);
  const month = date?.getMonth();
  const year = date?.getFullYear();

  const setDateYear = (value: number) => {
    if (!value || isNaN(value)) {
      return;
    }
    if (date === undefined) {
      setYear(new Date(), value);
      return;
    }

    const newDate = setYear(date, value);

    setDate?.(newDate);
  };
  const setYearFromString = (value: string | undefined) => {
    if (!value) {
      return;
    }
    setDateYear(Number(value));
  };

  const setMonthFromKey = (key: ISelectableOption['key'] | undefined) => {
    if (key === undefined || key === null) {
      return;
    }
    const monthOneIndex = Number(key);
    if (isNaN(monthOneIndex) || monthOneIndex < 0 || monthOneIndex > 11) {
      return;
    }

    if (date === undefined) {
      setMonth(new Date(), Number(key));
      return;
    }

    const newDate = setMonth(date, Number(key));

    setDate?.(newDate);
  };

  useEffect(() => {
    setDate?.(date);
    // set only on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const textYear = t('Year', { ns: 'search', defaultValue: 'Year' });
  const textMonth = t('Month', { ns: 'search', defaultValue: 'Month' });
  const textIncrease = t('Increase', {
    ns: 'search',
    defaultValue: 'Increase',
  });
  const textDecrease = t('Decrease', {
    ns: 'search',
    defaultValue: 'Decrease',
  });

  return (
    <>
      <Dropdown
        onChange={(_e, o) => setMonthFromKey(o?.key)}
        label={textMonth}
        selectedKey={month}
        options={monthList()}
        styles={{
          root: { width: '9em' },
          ...dropdownStyles(isDarkMode, theme),
        }}
      />
      <SpinButton
        min={2007}
        max={9999999}
        onValidate={setYearFromString}
        step={1}
        decrementButtonAriaLabel={textDecrease}
        incrementButtonAriaLabel={textIncrease}
        onChange={(_e, value) => setYearFromString(value)}
        //sets the frame title containing both the textfield AND the spin controllers
        title={textYear}
        label={textYear}
        labelPosition={Position.top}
        value={`${year}`}
        styles={{ root: { width: '6em' } }}
      />
    </>
  );
};
